import React, { useEffect, useState } from "react";
import { api, errMsg } from "../lib/api";
import { toast } from "sonner";
import { Switch } from "./ui/switch";
import { Loader2, Radar, Send } from "lucide-react";

const ScannerControls = () => {
  const [c, setC] = useState(null);
  const [chat, setChat] = useState("");
  const [busy, setBusy] = useState("");

  const apply = (d) => { setC(d); setChat(d.telegram_chat || ""); };
  useEffect(() => { api.get("/scanner/config").then(({ data }) => apply(data)).catch((e) => toast.error(errMsg(e))); }, []);

  const save = async (patch, msg) => {
    try { const { data } = await api.post("/scanner/config", patch); apply(data); toast.success(msg); }
    catch (e) { toast.error(errMsg(e, "Save failed.")); }
  };
  const act = async (key, url, ok) => {
    setBusy(key);
    try { const { data } = await api.post(url); toast.success(ok(data)); api.get("/scanner/config").then(({ data: d }) => apply(d)); }
    catch (e) { toast.error(errMsg(e, "Action failed.")); }
    setBusy("");
  };

  if (!c) return <div className="live-card sig-wait">Loading scanner…</div>;
  return (
    <div className="live-card scan-ctl" data-testid="scanner-controls">
      <div className="lc-eye"><Radar size={11} /> AI Scanner · Delivery</div>
      <div className="scan-ctl-row">
        <label>Scanner running</label>
        <Switch checked={c.enabled} onCheckedChange={(v) => save({ enabled: v }, v ? "Scanner ON" : "Scanner OFF")} data-testid="scanner-enabled-switch" />
      </div>
      <div className="scan-ctl-row">
        <label>Email signals to active members</label>
        <Switch checked={c.email_members} onCheckedChange={(v) => save({ email_members: v }, "Saved")} data-testid="scanner-email-switch" />
      </div>
      <div className="scan-ctl-row col">
        <label>Telegram channel (add @GwapTC_bot as admin)</label>
        <div className="scan-ctl-in">
          <input value={chat} onChange={(e) => setChat(e.target.value)} placeholder="@yourchannel" data-testid="scanner-telegram-input" />
          <button className="mini-btn" onClick={() => save({ telegram_chat: chat }, "Telegram channel saved")} data-testid="scanner-telegram-save">Save</button>
          <button className="mini-btn" disabled={!c.telegram_chat || busy === "tg"} onClick={() => act("tg", "/scanner/test-telegram", () => "Test sent to Telegram")} data-testid="scanner-telegram-test">
            {busy === "tg" ? <Loader2 size={11} className="spin" /> : <Send size={11} />} Test
          </button>
        </div>
      </div>
      <div className="scan-ctl-row">
        <span className="ac-sub" data-testid="scanner-last-scan">Last scan: {c.last_scan ? new Date(c.last_scan).toLocaleString() : "not yet"}</span>
        <button className="mini-btn" disabled={busy === "run"} onClick={() => act("run", "/scanner/run", (d) => d.status === "busy" ? "Scan already running" : `Scan done: ${d.candidates} candidates, ${d.published.length} published`)} data-testid="scanner-run-now">
          {busy === "run" ? <><Loader2 size={11} className="spin" /> Scanning…</> : "Run Scan Now"}
        </button>
      </div>
      {[c.last_error, c.telegram_error && `Telegram: ${c.telegram_error}`, c.email_error && `Email: ${c.email_error}`].filter(Boolean).map((e) => (
        <div className="scan-err" key={e} data-testid="scanner-delivery-error">{e}</div>
      ))}
    </div>
  );
};

export default ScannerControls;
